module.exports = __webpack_public_path__ + "cc84fd0e65fc60bd8a8954973b323183.svg";